module.exports = __webpack_public_path__ + "img/share.49d38366.png";